import script from "./MarkdownRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownRenderer.vue?vue&type=style&index=0&id=23f78aff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f78aff"]])

export default __exports__